<template>
  <div
    v-loading="loading"
    class="basic-form"
  >
    <el-container class="common-container">
      <el-main class="main">
        <div class="form-title">
          <span>
            基本资料
          </span>
        </div>
        <div class="form">
          <el-form
            ref="form"
            :model="form"
            label-width="80px"
            :rules="rules"
          >
            <el-form-item
              label="头像"
              prop="gravatar"
            >
              <el-upload
                class="avatar-uploader"
                action="https://jsonplaceholder.typicode.com/posts/"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
              >
                <img
                  v-if="imageUrl"
                  :src="imageUrl"
                  class="avatar"
                >
                <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                ></i>
              </el-upload>
              <div class="upload-reminder">
                只能上传jpg/png文件，不超过2M
              </div>
            </el-form-item>
            <el-form-item
              label="姓名"
              prop="name"
            >
              <mk-input
                v-model="form.name"
                placeholder="输入姓名"
                maxlength="15"
                show-word-limit
              ></mk-input>
            </el-form-item>
            <el-form-item
              label="职位"
              prop="position"
            >
              <mk-input
                v-model="form.position"
                placeholder="输入职位"
                maxlength="15"
                show-word-limit
              ></mk-input>
            </el-form-item>
            <el-form-item
              label="公司"
              prop="company"
            >
              <mk-input
                v-model="form.company"
                placeholder="输入公司"
                disabled
              ></mk-input>
            </el-form-item>
            <el-form-item
              label="手机号"
              prop="mobile"
            >
              <mk-input
                v-model="form.mobile"
                placeholder="输入手机号"
                maxlength="11"
                show-word-limit
              ></mk-input>
            </el-form-item>
            <el-form-item
              label="座机"
              prop="telephone"
            >
              <mk-input
                v-model="form.telephone"
                placeholder="输入座机"
                maxlength="20"
                show-word-limit
              ></mk-input>
            </el-form-item>
            <el-form-item
              label="微信"
              prop="wechat"
            >
              <mk-input
                v-model="form.wechat"
                placeholder="输入区块标题"
                maxlength="20"
                show-word-limit
              ></mk-input>
            </el-form-item>
            <el-form-item
              label="邮箱"
              prop="mail"
            >
              <mk-input
                v-model="form.mail"
                placeholder="输入区块标题"
                maxlength="30"
                show-word-limit
              ></mk-input>
            </el-form-item>
            <el-form-item
              label="地址"
              prop="detailAddress"
              class="form-item-specil"
            >
              <mk-select
                v-model="detailAddress1"
                placeholder="请选择"
                class="input-specil input-specil-mr"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </mk-select>
              <mk-select
                v-model="detailAddress2"
                placeholder="请选择"
                class="input-specil"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </mk-select>
            </el-form-item>
            <el-form-item>
              <mk-input
                v-model="detailAddress3"
                placeholder="输入详细地址"
                maxlength="30"
                show-word-limit
              ></mk-input>
            </el-form-item>
          </el-form>
        </div>
      </el-main>
      <div
        class="button-footer"
        height="56"
      >
        <el-button
          type="primary"
          size="small"
          @click="saveBasicInfo"
        >
          保存
        </el-button>
      </div>
    </el-container>
  </div>
</template>

<script>
import { JINGTUIAPIS } from '../../../../../../../api'
export default {
  name: 'BasicForm',
  props: {
    formData: {
      type: Object,
      default: () => {
        return {
          gravatar:
            'https://gss0.bdstatic.com/-4o3dSag_xI4khGkpoWK1HF6hhy/baike/w%3D268%3Bg%3D0/sign=d6c79a914490f60304b09b410129d426/91ef76c6a7efce1bc153de6aa151f3deb48f6511.jpg',
          name: '',
          position: '',
          company: '',
          mobile: '',
          telephone: '',
          wechat: '',
          mail: '',
          detailAddress: ''
        }
      }
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // 表单数据
      form: {
        gravatar: '',
        name: '',
        position: '',
        company: '',
        mobile: '',
        telephone: '',
        wechat: '',
        mail: '',
        detailAddress: ''
      },
      // 详细地址
      detailAddress1: '',
      // 详细地址
      detailAddress2: '',
      // 详细地址
      detailAddress3: '',
      // 表单验证
      rules: {
        gravatar: [{ required: true, message: '请上传头像', trigger: 'blur' }],
        name: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
        position: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        email: [
          { type: 'email', message: '请输入正确的邮箱格式', trigger: 'change' }
        ]
      },
      // 图片url
      imageUrl: '',
      options: [
        {
          value: '选项1',
          label: '黄金糕'
        },
        {
          value: '选项2',
          label: '双皮奶'
        }
      ],
      value: '',
      // 是否正在请求
      loading: false
    }
  },
  watch: {
    formData (newVal, oldVal) {
      this.form = this._.cloneDeep(newVal)
    }
  },
  methods: {
    handleAvatarSuccess (file) {
    },
    beforeAvatarUpload (file) {
    },
    // 保存数据
    saveBasicInfo () {
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.loading = true
          let res = await JINGTUIAPIS.CardApi.cardPut(
            {
              id: this.id
            },
            {
              profile: this.form
            }
          )
          this.loading = false
          if (res.success) {
            this.$message.success('保存成功')
            this.form = res.data[0].profile
          }
        } else {
          this.$message.error('有必填项未填写')
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.basic-form {
  background-color: #fff;
  height: 100%;
  width: 100%;

  .form {
    margin-top: 30px;
  }

  .upload-reminder {
    font-size: 12px;
    color: #8c8c8c;
  }

  .input-specil {
    width: 153px;
  }

  .input-specil-mr {
    margin-right: 14px;
  }

  /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  /deep/ .el-upload:hover {
    border-color: #409eff;
  }

  /deep/ .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
  }

  /deep/ .avatar {
    width: 50px;
    height: 50px;
    display: block;
  }
}
</style>
